module.exports = __webpack_public_path__ + "static/img/a.9b43dcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/a.png
// module id = /BKZ
// module chunks = 1